import { Icon } from "@iconify/react";
import React, { useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import useApi from "../../hook/useApi";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // const verificationToken = searchParams.get("token") || "";

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const { AsyncPatchApiCall } = useApi();

  const location = useLocation();
  const verificationToken = location.pathname.split("token=")[1] || "";


  //password validation rules
  const validatePassword = (password) => {
    const minLength = password.length >= 6;
    const hasUppercase = /[A-Z]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    return minLength && hasUppercase && hasSpecialChar;
  };

  // ✅ Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    if (!password) {
      setErrors({ password: "Password is required" });
      return;
    }
    if (!validatePassword(password)) {
      setErrors({
        password:
          "Password must be at least 6 characters, include one uppercase letter and one special character",
      });
      return;
    }
    if (!confirmPassword) {
      setErrors({ confirmPassword: "Confirm Password is required" });
      return;
    }
    if (password !== confirmPassword) {
      setErrors({ confirmPassword: "Passwords do not match" });
      return;
    }
    if (!verificationToken) {
      setErrors({ general: "Invalid or missing verification token" });
      return;
    }

    try {
      setLoading(true);

      const res = await AsyncPatchApiCall("/admin/reset-password", {
        verificationToken: verificationToken,
        newPassword: password,
        confirmPassword: confirmPassword,
      });

      if (res?.success) {
        toast.success("Password reset successfully!");
        navigate("/login");
      } else {
        console.log('res0',res)
        toast.error(res?.data?.message || "Failed to reset password");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          "Failed to reset password. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}

      <section className="auth bg-base d-flex flex-wrap">
        {/* Left Side Image */}
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src="assets/images/signup.svg" alt="Reset Password Visual" />
          </div>
        </div>

        {/* Right Side Form */}
        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
            <div>
              <Link to="/" className="mb-40 max-w-290-px d-block">
                <img src="assets/images/logo.svg" alt="Logo" />
              </Link>
              <h4 className="mb-12">Reset Your Password</h4>
              <p className="mb-32 text-secondary-light text-lg">
                Enter your new password below
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              {/* New Password */}
              <div className="position-relative mb-20">
                <div className="icon-field" style={{ display: "flex" }}>
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="solar:lock-password-outline" />
                  </span>
                  <input
                    type={passwordVisible ? "text" : "password"}
                    className={`form-control h-56-px bg-neutral-50 radius-12 ${
                      errors.password ? "is-invalid" : ""
                    }`}
                    placeholder="Enter New Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    className="icon password-eye-icon top-50 translate-middle-y"
                    style={{
                      position: "absolute",
                      right: `${errors.password ? "1em" : "0"}`,
                      cursor: "pointer",
                    }}
                    onClick={() => setPasswordVisible(!passwordVisible)}
                  >
                    <Icon
                      icon={
                        passwordVisible
                          ? "solar:eye-closed-bold"
                          : "solar:eye-bold"
                      }
                    />
                  </span>
                </div>
                {errors.password && (
                  <div className="invalid-feedback d-block">
                    {errors.password}
                  </div>
                )}
              </div>

              {/* Confirm Password */}
              <div className="position-relative mb-20">
                <div className="icon-field" style={{ display: "flex" }}>
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="solar:lock-password-outline" />
                  </span>
                  <input
                    type={confirmPasswordVisible ? "text" : "password"}
                    className={`form-control h-56-px bg-neutral-50 radius-12 ${
                      errors.confirmPassword ? "is-invalid" : ""
                    }`}
                    placeholder="Confirm New Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <span
                    className="icon password-eye-icon top-50 translate-middle-y"
                    style={{
                      position: "absolute",
                      right: `${errors.confirmPassword ? "1em" : "0"}`,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setConfirmPasswordVisible(!confirmPasswordVisible)
                    }
                  >
                    <Icon
                      icon={
                        confirmPasswordVisible
                          ? "solar:eye-closed-bold"
                          : "solar:eye-bold"
                      }
                    />
                  </span>
                </div>
                {errors.confirmPassword && (
                  <div className="invalid-feedback d-block">
                    {errors.confirmPassword}
                  </div>
                )}
              </div>

              {/* General Error */}
              {errors.general && (
                <div className="text-danger text-center mb-3">
                  {errors.general}
                </div>
              )}

              <button
                type="submit"
                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-16"
              >
                Reset Password
              </button>

              <div className="text-center mt-16">
                <Link to="/login" className="text-primary-600 fw-medium">
                  Back to Login
                </Link>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResetPassword;
